import {
    GROUP_DETAIL_REQUESTED,
    GROUP_DETAIL_RECEIVED,
    GROUP_DETAIL_ERROR
} from '../actions/groupDetail.js';
import RequestState from "../storage/RequestState";
import RequestResult from "../storage/RequestResult";
import {EMPTY_REQUEST_RESULT_INIT_STATE} from "../utils/JsObjectHelper";

/**
 *
 * @param {RequestResult} state
 * @param {BaseAction|ReceiveEntryTypesAction|ReceiveErrorAction} action
 * @return {RequestResult}
 */
export const groupDetail = (state = EMPTY_REQUEST_RESULT_INIT_STATE, action)  => {

    switch (action.type) {
        case GROUP_DETAIL_REQUESTED:
            return new RequestResult(RequestState.getInstanceLoading(), state.data);
        case GROUP_DETAIL_RECEIVED:
            return new RequestResult(RequestState.getInstanceDone(), action.groupDetail, action.receivedAt);
        case GROUP_DETAIL_ERROR:
            return new RequestResult(
                RequestState.getInstanceError(
                    action.errorResponseStatusCode,
                    action.errorResponseMessage ? action.errorResponseMessage : null
                ),
                state.getData()
            );
        default:
            return state
    }
};
